import { pushAndWait } from '../navigate';
import type { AutopilotFunctionFactory } from '../types';

export const createGotoCreateOrderFunction: AutopilotFunctionFactory = ({ router }) => ({
  name: 'goto_create_order',
  description: 'Open the new-order wizard. This ONLY navigates; nothing is saved until the user finishes the wizard.',
  parameters: { type: 'object', properties: {} },
  handler: async () => {
    await pushAndWait(router, { name: 'order.create' });
    return { success: true };
  },
});
